import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "level is-mobile h-100" }
const _hoisted_2 = { class: "level-left mt-0" }
const _hoisted_3 = { class: "level-item" }
const _hoisted_4 = {
  key: 1,
  class: "widget-title"
}
const _hoisted_5 = { class: "level-right mt-0" }
const _hoisted_6 = { class: "level-item" }
const _hoisted_7 = { class: "widget-body" }
const _hoisted_8 = { class: "w-100 h-100 widget-body no-data" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_spin = _resolveComponent("n-spin")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["widget", { 'no-padding': !_ctx.padding, 'no-header': !_ctx.title && !_ctx.$slots['header-left'] && !_ctx.$slots['header-right']}])
  }, [
    (_ctx.title || _ctx.$slots['header-left'] || _ctx.$slots['header-right'])
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["widget-header", { 'mb-0': !_ctx.title }])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_ctx.$slots['header-left'])
                  ? _renderSlot(_ctx.$slots, "header-left", { key: 0 })
                  : _createCommentVNode("v-if", true),
                (_ctx.title)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.title), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "header-right")
              ])
            ])
          ])
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      _renderSlot(_ctx.$slots, "default")
    ], 512 /* NEED_PATCH */), [
      [_vShow, !_ctx.empty]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_8, [
      _createVNode(_component_n_spin, { size: "large" })
    ], 512 /* NEED_PATCH */), [
      [_vShow, _ctx.empty]
    ])
  ], 2 /* CLASS */))
}